import { FolderAccess } from '~/features/upload/types';
import { intlService } from '~/i18n/IntlService';
import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  folderId: PilotId;
}

interface Response {
  can_modify_folder: boolean;
  folder_access_list: {
    members: any[];
    departments: any[];
  };
  visibility_level: string;
}

export const getFolderVisibility = async ({
  folderId,
}: Request): Promise<FolderAccess> => {
  const url = folderId
    ? `/folder/visibility/${folderId}/`
    : '/folder/visibility/';

  const response: Response = await pilot.get(url);

  if (!response.can_modify_folder) {
    throw new Error(
      intlService.getIntl().formatMessage({
        id: 'getFolderVisibility.noPermissionError',
        defaultMessage: 'You do not have permission to modify this folder.',
        description:
          'Error message when user lacks permission to modify folder',
      }),
    );
  }
  return { canModifyFolder: response.can_modify_folder };
};
